import { atom } from 'jotai';
import { Connection } from '@/../../server/types/apiTypes';

export const PYMKInboxMessageAtom = atom<Connection[]>([]);
export const shouldContinueFetchingAtom = atom<boolean>(false);
export const localSeenStatusAtom = atom<Record<string, boolean>>({});
